const keyElementsById = <T extends { id: number }>(
  array: T[],
): { [key: number]: T } =>
  Object.fromEntries(array.map(element => [element.id, element]));

export default keyElementsById;
